module.exports = __webpack_public_path__ + "static/media/avatar.6e0f7481.png";